import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { AccountService } from '@services/core/account/account.service';
import { ISendPasswordResetCode } from '@models/data/account/form-data/ISendPasswordResetCode';
import { PublicRoutes } from '@shared/common/routing/public-routes';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { ButtonComponent } from '../../shared/components/buttons/button/button.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { RouterLink } from '@angular/router';
import { FormControlErrorDirective } from '../../shared/directives/form-control-error/form-control-error.directive';
import { FitmedLogoWhiteComponent } from '../../shared/components/fitmed-logo-white/fitmed-logo-white.component';

@Component({
    selector: 'app-account-forgot-password',
    templateUrl: './account-forgot-password.component.html',
    styleUrls: ['./account-forgot-password.component.scss'],
    standalone: true,
    imports: [FitmedLogoWhiteComponent, ReactiveFormsModule, FormControlErrorDirective, RouterLink, IconComponent, ButtonComponent, LocalizeTextPipe]
})
export class AccountForgotPasswordComponent extends IconsDefinitionHelper implements OnInit {
  loading$ = false;
  loginUrl = PublicRoutes.ACCOUNT.login.fullUrl;

  forgotPasswordForm = new UntypedFormGroup({
    emailAddress: new UntypedFormControl(environment.production ? '' : 'ncorrie@pernix.com.au', [Validators.required]),
  });

  constructor(private accountService: AccountService) {
    super();
  }

  ngOnInit(): void {
  }

  submit(): void {
    const formData = this.forgotPasswordForm.getRawValue();

    const resetPasswordData: ISendPasswordResetCode = {
      email: formData.emailAddress,
      // appName: 'MVC',
      appName: 'FitMed',
      returnUrl: `${environment.application.baseUrl}/account/reset-password`
    };

    this.loading$ = true;
    this.accountService.sendResetPasswordCode(resetPasswordData).then(_ => this.loading$ = false);
  }

}
